import { Popover as BasePopover } from '@base-ui/react/popover';
import type { ComponentProps, FC, ReactNode } from 'react';
import { cn } from './react';

export type PopoverProps = {
  children?: ReactNode;
  className?: string;
};

export const PopoverRoot = BasePopover.Root;

export const PopoverTrigger: FC<{
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  openOnHover?: boolean;
}> = (props) => (
  <BasePopover.Trigger {...props} onClick={(e) => e.stopPropagation()} />
);

export const PopoverContent: FC<{
  children?: ReactNode;
  className?: string;
  side?: ComponentProps<typeof BasePopover.Positioner>['side'];
  align?: ComponentProps<typeof BasePopover.Positioner>['align'];
  initialFocus?: ComponentProps<typeof BasePopover.Popup>['initialFocus'];
  finalFocus?: ComponentProps<typeof BasePopover.Popup>['finalFocus'];
}> = ({ children, side, align, className, initialFocus, finalFocus }) => (
  <BasePopover.Portal container={document.getElementById('portal-root')}>
    <BasePopover.Backdrop />
    <BasePopover.Positioner
      positionMethod="fixed"
      sideOffset={8}
      align={align}
      side={side}
      collisionPadding={8}
    >
      <BasePopover.Popup
        className={cn(
          'transition-all duration-150 ease-out opacity-100 scale-100 translate-0 shadow-2xl shadow-shades-black-10 origin-top rounded-xl border border-border-disabled bg-background-primary',
          'data-starting-style:opacity-0 data-starting-style:translate-y-1.5',
          'data-ending-style:opacity-0 data-ending-style:-translate-y-1.5',
          'max-h-[50svh] overflow-auto scrollbar-none',
          className,
        )}
        onClick={(e) => e.stopPropagation()}
        initialFocus={initialFocus}
        finalFocus={finalFocus}
      >
        {children}
      </BasePopover.Popup>
    </BasePopover.Positioner>
  </BasePopover.Portal>
);
